var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgMenuCustomers = function SvgMenuCustomers(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "MC_1_",
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "MC_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MC_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MC_2_)",
    fill: "#00C752",
    d: "M35.695,19.166c0,0.552,0.448,1,1,1s1-0.448,1-1c0-0.552-0.448-1-1-1 S35.695,18.613,35.695,19.166"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MC_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M12.218,29.557h-0.01c-0.453,0-0.846-0.155-1.149-0.44c-0.656-0.599-0.737-1.616-0.175-2.259l2.027-2.307 c0.928-0.906,2.096-0.23,2.376,0.042c0.619,0.571,0.693,1.45,0.095,2.129l-2.06,2.341c-0.102,0.117-0.293,0.247-0.502,0.346 C12.483,29.52,12.218,29.557,12.218,29.557z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MC_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M6.989,21.86c0.696,0.606,1.041,0.892,1.695,1.376l0.598,0.443"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MC_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M23.148,30.617c0.426,0.326,0.701,0.785,0.721,1.215c0.014,0.362-0.133,0.725-0.451,1.016c-0.639,0.619-1.543,0.739-2.415,0.273 c-0.393-0.218-0.727-0.445-1.062-0.74l-0.563-0.455"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MC_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M13.385,13.873c0.204,0.135,1.518,0.711,3.074,1.265l0.931,0.332l-2.568,3.488c-0.345,0.461-0.25,1.128,0.206,1.481 c0.899,0.693,2.349,0.622,3.182-0.156l2.017-1.887c0.638-0.606,1.68-0.776,2.449-0.395c4.111,2.045,6.598,4.403,8.674,6.646 c0.149,0.162,0.628,0.742,0.605,1.455c-0.014,0.412-0.189,0.781-0.521,1.096c-0.172,0.16-0.614,0.497-1.232,0.497 c-0.375,0-0.758-0.13-1.107-0.372l-4.1-3.16l3.479,2.672c0.67,0.523,0.803,1.547,0.308,2.23c-0.253,0.333-0.604,0.549-1,0.611 l-0.22,0.017c-0.338,0-0.655-0.11-0.924-0.317l-3.496-2.699l2.662,2.064c0.672,0.525,0.805,1.528,0.297,2.213 c-0.244,0.334-0.602,0.551-1.008,0.605l-0.205,0.016c-0.336,0-0.656-0.11-0.92-0.317l-1.803-1.413"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MC_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M26.694,14.378l-4.658-0.886c-0.196-0.027-0.423-0.043-0.646-0.043c-1.367,0-2.708,0.595-3.659,1.63L17.39,15.47"
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#MC_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 33.053,
    y1: 21.932,
    x2: 30.871,
    y2: 24.082
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MC_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M32.676,21.281l0.705,1.217c0.268,0.465,0.895,0.652,1.381,0.371l4.166-2.402c0.48-0.282,0.65-0.903,0.371-1.383l-5.807-10.06 c-0.271-0.466-0.936-0.631-1.383-0.371l-4.164,2.405c-0.232,0.135-0.4,0.354-0.471,0.616c-0.069,0.262-0.035,0.533,0.102,0.768 L32.676,21.281z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MC_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M17.588,33.141L17.588,33.141c-0.397,0-0.794-0.146-1.124-0.41c-0.047-0.038-0.591-0.479-0.636-1.066 c-0.04-0.486,0.306-0.837,0.419-0.951l1.113-1.273c0.342-0.387,0.719-0.58,1.121-0.58c0.449,0,0.767,0.248,0.887,0.34 c0.781,0.645,0.922,1.556,0.368,2.281c-0.449,0.582-0.693,0.857-1.086,1.239C18.366,32.993,17.989,33.141,17.588,33.141z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MC_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M14.624,31.783c-0.445,0-0.836-0.156-1.146-0.439c-0.664-0.607-0.742-1.622-0.175-2.262l2.056-2.338 c0.313-0.35,0.675-0.54,1.052-0.561l0.062-0.004l0.089,0.01c0.276,0.006,0.571,0.127,0.858,0.389c0.78,0.7,0.944,1.668,0.368,2.371 l-2.075,2.359c-0.258,0.299-0.65,0.449-1.086,0.475H14.624z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MC_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M10.143,27.053c-0.61-0.008-1.078-0.475-1.208-0.619c-0.577-0.517-0.697-1.287-0.254-1.908c0.361-0.502,0.69-0.879,1.178-1.346 c0.58-0.554,1.689-0.397,2.307,0.256c0.412,0.491,0.588,1.211-0.013,1.963l-1.068,1.217C10.743,26.932,10.439,27.053,10.143,27.053 z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MC_2_)",
    fill: "#00C752",
    d: "M12.961,11.557c-0.102-0.377-0.342-0.692-0.68-0.889L8.118,8.264 C7.477,7.891,6.496,8.153,6.119,8.799L0.314,18.858c-0.404,0.692-0.165,1.587,0.535,1.999l4.165,2.402 c0.218,0.126,0.467,0.192,0.72,0.192h0.001c0.528,0,1.017-0.279,1.274-0.728l5.805-10.055 C13.01,12.331,13.063,11.937,12.961,11.557"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MC_2_)",
    fill: "#63666A",
    d: "M2.795,20.25c-0.552,0-1-0.448-1-1s0.448-1,1-1c0.552,0,1,0.448,1,1 S3.347,20.25,2.795,20.25"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuCustomers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-customers.15af4176.svg";
export { ForwardRef as ReactComponent };